<button
  [type]="type"
  [class]="hostClasses"
  [disabled]="disabled || loading"
  (click)="onClick($event)">

  <lucide-icon
    *ngIf="loading"
    [name]="spinnerIcon"
    [size]="iconSize"
    class="pay-btn__spinner">
  </lucide-icon>

  <lucide-icon
    *ngIf="icon && !loading && iconPosition === 'left'"
    [name]="icon"
    [size]="iconSize"
    class="pay-btn__icon pay-btn__icon--left">
  </lucide-icon>

  <span *ngIf="label" class="pay-btn__label">{{ label }}</span>

  <lucide-icon
    *ngIf="icon && !loading && iconPosition === 'right'"
    [name]="icon"
    [size]="iconSize"
    class="pay-btn__icon pay-btn__icon--right">
  </lucide-icon>
</button>
